import React from 'react';
import { Box, Text, TextButton } from 'wix-style-react';
import withAppMode from '../../../providers/appMode/withAppMode';
import { AppMode } from '../../../constants/app-mode';
var SystemTemplateBubble = function (_a) {
    var message = _a.message, eventHooks = _a.eventHooks, appMode = _a.appMode;
    if (appMode !== AppMode.FullApp) {
        return null;
    }
    var _b = message.templateData, text = _b.text, buttons = _b.buttons;
    var button = buttons === null || buttons === void 0 ? void 0 : buttons[0];
    return (React.createElement(Box, { dataHook: "system-template-wrapper", direction: "vertical", align: "center", verticalAlign: "middle", textAlign: "center", maxWidth: "300px" },
        React.createElement(Text, { dataHook: "system-template-text", secondary: true, light: true, size: "tiny" }, text),
        React.createElement(TextButton, { dataHook: "system-template-button", size: "tiny", onClick: function () {
                var _a;
                (_a = eventHooks === null || eventHooks === void 0 ? void 0 : eventHooks.onCallToActionClick) === null || _a === void 0 ? void 0 : _a.call(eventHooks, button === null || button === void 0 ? void 0 : button.cta);
            } }, button === null || button === void 0 ? void 0 : button.text)));
};
export default withAppMode(SystemTemplateBubble);
//# sourceMappingURL=SystemTemplateBubble.js.map